export default __webpack_public_path__ + "static/media/TVM logo.e6da1f55.jpg";